/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';
import { getComparisonMatrix, GetComparisonMatrix$Params } from '../fn/selectables/get-comparison-matrix';
import { getComponentsInfo, GetComponentsInfo$Params } from '../fn/selectables/get-components-info';
import { getSelectables, GetSelectables$Params } from '../fn/selectables/get-selectables';
import { ComparisonMatrix } from '../models/comparison-matrix';
import { ComponentsInfo } from '../models/components-info';
import { SelectablesResponse } from '../models/selectables-response';
import { StrictHttpResponse } from '../strict-http-response';

/**
 * Get selectable vehicle components
 */
@Injectable({ providedIn: 'root' })
export class SelectablesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSelectables()` */
  static readonly GetSelectablesPath = '/api/v3/{market}/{subProcess}/{dataVersion}/vehicles/{vehicleId}/selectables';

  /**
   * Get selectables for vehicle-id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSelectables()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSelectables$Response(
    params: GetSelectables$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<SelectablesResponse>> {
    return getSelectables(this.http, this.rootUrl, params, context);
  }

  /**
   * Get selectables for vehicle-id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSelectables$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSelectables(params: GetSelectables$Params, context?: HttpContext): Observable<SelectablesResponse> {
    return this.getSelectables$Response(params, context).pipe(
      map((r: StrictHttpResponse<SelectablesResponse>): SelectablesResponse => r.body)
    );
  }

  /** Path part for operation `getComparisonMatrix()` */
  static readonly GetComparisonMatrixPath =
    '/api/v3/{market}/{subProcess}/{dataVersion}/models/{modelId}/selectables/{categoryId}/compare';

  /**
   * Get a comparison matrix of compared components and their included-components for a category-id and model-id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getComparisonMatrix()` instead.
   *
   * This method doesn't expect any request body.
   */
  getComparisonMatrix$Response(
    params: GetComparisonMatrix$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ComparisonMatrix>> {
    return getComparisonMatrix(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a comparison matrix of compared components and their included-components for a category-id and model-id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getComparisonMatrix$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getComparisonMatrix(params: GetComparisonMatrix$Params, context?: HttpContext): Observable<ComparisonMatrix> {
    return this.getComparisonMatrix$Response(params, context).pipe(
      map((r: StrictHttpResponse<ComparisonMatrix>): ComparisonMatrix => r.body)
    );
  }

  /** Path part for operation `getComponentsInfo()` */
  static readonly GetComponentsInfoPath = '/api/v3/{market}/{subProcess}/{dataVersion}/models/{modelId}/componentsInfo';

  /**
   * Get detailed information of all components for a model-id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getComponentsInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getComponentsInfo$Response(
    params: GetComponentsInfo$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ComponentsInfo>> {
    return getComponentsInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * Get detailed information of all components for a model-id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getComponentsInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getComponentsInfo(params: GetComponentsInfo$Params, context?: HttpContext): Observable<ComponentsInfo> {
    return this.getComponentsInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<ComponentsInfo>): ComponentsInfo => r.body)
    );
  }
}
